import { Stack, Group, Text, Box, Paper } from "@mantine/core";
import { IconBadge } from "../common/IconBadge";
import { PanelHeader } from "../common/PanelHeader";
import { AppIcon } from "../common/AppIcon";
import { liveActivity } from "../../data/mockData";

const shadow = "0 1px 8px rgba(0,0,0,0.05)";

function ActivityRow({ item }) {
  return (
    <Group gap="sm" wrap="nowrap" align="center">
      <IconBadge icon={item.icon} color={item.color} size={40} />
      <Stack gap={4} style={{ minWidth: 0 }}>
        <Text fz="md" fw={400} lh={1.25}>
          {item.title}
        </Text>
        <Text fz="sm" c="gray.5">
          {item.time}
        </Text>
      </Stack>
    </Group>
  );
}

export function LiveActivityPanel() {
  return (
    <Paper
      bg={"#fcfbff"}
      p="xl"
      radius="lg"
      withBorder
      style={{
        borderColor: "#edebeb",
        boxShadow: shadow,
      }}
    >
      <PanelHeader
        leading={
          <Box c="#4664e2" style={{ display: "flex" }}>
            <AppIcon name="broadcast" size={22} />
          </Box>
        }
        title="Activité en direct"
        subtitle="Votre prospection en temps réel"
      />
      <Stack gap="lg">
        {liveActivity.map((item) => (
          <ActivityRow key={item.id} item={item} />
        ))}
      </Stack>
    </Paper>
  );
}

export default LiveActivityPanel;
